import { render, staticRenderFns } from "./Index-Bill-Details.vue?vue&type=template&id=4a3f837a"
import script from "./Index-Bill-Details.vue?vue&type=script&lang=js"
export * from "./Index-Bill-Details.vue?vue&type=script&lang=js"
import style0 from "./Index-Bill-Details.vue?vue&type=style&index=0&id=4a3f837a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports